import React from 'react';
import Sidebar from '../Components/Sidebar';
import { Link } from 'react-router-dom';
import { Dropdown, Carousel, Button } from 'react-bootstrap';
import slider2 from '../Components/Image/slider2.jpg'
import slider3 from '../Components/Image/slider3.jpg'
import slider4 from '../Components/Image/slider4.jpg'
import carausel5 from '../Components/Image/carousel5.jpeg'
import SMSGroup from '../Components/Image/SMSGroup.png'
// import carausel3 from '../Components/Image/Carousel3'
import { connect } from 'react-redux'
import { getQATemplates } from '../store/actions/qaTemplateActions'
import { getPODetails, getPOSearch, postPOLineItem, inspectionDashboard, getSupplierPOs } from '../store/actions/poDetailsActions'
import { getDepartmentSearch } from '../store/actions/departmentActions'

import authInstance from '../Classes/AuthHandler';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuthHandlerInstance from '../Classes/AuthHandler'

class AdvanceDashboard extends React.Component {

    componentDidMount() {
        NotificationManager.info('Info message');
        const form = {
            //  POId: req.params.id,
            PurchaseOrderLineId: 'req.params.lineid',
            QATemplateName: 'req.body.template',
            TemplateId: 'req.body.TemplateId',
            SeqNo: 'req.body.SeqNo',
            StageId: 'req.body.StageId'

        }
        // this.props.getQATemplates()
        // this.props.getPODetails(1)
        // this.props.getDepartmentSearch()
        // // this.props.postPOLineItem(form)
        // this.props.inspectionDashboard()
        // this.props.getSupplierPOs()
    }
    render() {

        var roles = AuthHandlerInstance.getRoles()
        var groups = authInstance.getGroups()
        const { qaTemplate } = this.props.qaTemplate
        console.log(qaTemplate)
        console.log(this.props.poDetails)
        var roles = authInstance.getRoles()
        console.log("roles=", roles, "groups=", groups)

        console.log(roles)
        return (
            <div className="container-fluid" style={{ padding: 0 }}>
                <Carousel className="container-fluid">
                    <Carousel.Item>
                        <img src={slider4} style={{ width: "100%", height: 400, objectFit: "cover" }} />
                        <div className="container-fluid mr-6">
                            <span className="sms-content-slider-header">HIGHLIGHT PROJECTS</span>
                            <span className="sms-content-slider-subheader">SMS Group</span>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={slider2} style={{ width: "100%", height: 400, objectFit: "cover" }} />
                        <div className="container-fluid mr-6">
                            <span className="sms-content-slider-header">HIGHLIGHT PROJECTS</span>
                            <span className="sms-content-slider-subheader">SMS Group</span>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={slider3} style={{ width: "100%", height: 400, objectFit: "cover" }} />
                        <div className="container-fluid mr-6">
                            <span className="sms-content-slider-header">HIGHLIGHT PROJECTS</span>
                            <span className="sms-content-slider-subheader">SMS Group</span>
                        </div>
                    </Carousel.Item>


                </Carousel>

                <div className="row pt-4 pb-4">

                    {roles[7] == true && groups[7] == true ?
                        <div className="row flex-sm-fill mr-4 ml-2">
                            <div className="col-sm-4">
                                <a href="RequestPayment" className="avatar avatar-lg rounded-circle" >

                                    <div className="card card-fluid">
                                        <div className="card-body text-center">
                                            <div className="avatar-parent-child">
                                                <a className="avatar avatar-lg rounded-circle">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"paper-plane"} color={"black"} title="Accept" size="4x" />
                                                </a>
                                                <span className="avatar-child avatar-badge bg-success" />
                                            </div>
                                            <h5 className="h6 mt-4 mb-0">Proritize</h5>

                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        :

                        roles[10] == true && groups[11] == true ?
                            <div className="row flex-sm-fill mr-4 ml-2">
                                <div className="col-sm-4">
                                    <a href="SendforPayment" className="avatar avatar-lg rounded-circle" >

                                        <div className="card card-fluid">
                                            <div className="card-body text-center">
                                                <div className="avatar-parent-child">
                                                    <a className="avatar avatar-lg rounded-circle">
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"paper-plane"} color={"black"} title="Accept" size="4x" />
                                                    </a>
                                                    <span className="avatar-child avatar-badge bg-success" />
                                                </div>
                                                <h5 className="h6 mt-4 mb-0">Send Invoices for Payment</h5>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            :

                            roles[8] == true && groups[9] == true ?

                                <div className="row flex-sm-fill mr-4 ml-2">
                                    <div className="col-sm-4">
                                        <a href="RequestPayment" className="avatar avatar-lg rounded-circle" >

                                            <div className="card card-fluid">
                                                <div className="card-body text-center">
                                                    <div className="avatar-parent-child">
                                                        <a className="avatar avatar-lg rounded-circle">
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"paper-plane"} color={"black"} title="Accept" size="4x" />
                                                        </a>
                                                        <span className="avatar-child avatar-badge bg-success" />
                                                    </div>
                                                    <h5 className="h6 mt-4 mb-0">Received Invoices from AP Team</h5>

                                                    {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-4 mt-2">
                                        <a href="UploadPaymentAcknowledgement" className="avatar avatar-lg rounded-circle" >

                                            <div className="card card-fluid">
                                                <div className="card-body text-center">
                                                    <div className="avatar-parent-child">
                                                        <a className="avatar avatar-lg rounded-circle">
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"share-square"} color={"black"} title="Accept" size="4x" />
                                                        </a>
                                                        <span className="avatar-child avatar-badge bg-success" />
                                                    </div>
                                                    <h5 className="h6 mt-4 mb-0">Invoices for Payment</h5>

                                                    {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                </div>
                                            </div>
                                        </a>
                                    </div>

                                </div>


                                :

                                roles[9] == true && groups[10] == true ?
                                    <div className="row flex-sm-fill mr-4 ml-2">
                                        <div className="col-sm-4">
                                            <a href="RequestPayment" className="avatar avatar-lg rounded-circle" >

                                                <div className="card card-fluid">
                                                    <div className="card-body text-center">
                                                        <div className="avatar-parent-child">
                                                            <a className="avatar avatar-lg rounded-circle">
                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"paper-plane"} color={"black"} title="Accept" size="4x" />
                                                            </a>
                                                            <span className="avatar-child avatar-badge bg-success" />
                                                        </div>
                                                        <h5 className="h6 mt-4 mb-0">Set Budget</h5>

                                                        {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    :

                                    roles[8] == true && groups[8] == true ?
                                        <div className="row flex-sm-fill mr-4 ml-2">
                                            <div className="col-sm-4">
                                                <a href="RequestPayment" className="avatar avatar-lg rounded-circle" >

                                                    <div className="card card-fluid">
                                                        <div className="card-body text-center">
                                                            <div className="avatar-parent-child">
                                                                <a className="avatar avatar-lg rounded-circle">
                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"paper-plane"} color={"black"} title="Accept" size="4x" />
                                                                </a>
                                                                <span className="avatar-child avatar-badge bg-success" />
                                                            </div>
                                                            <h5 className="h6 mt-4 mb-0">Received Invoices from Supplier</h5>

                                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-sm-4 pt-2">
                                                <a href="/AdvancedReceivePayments" className="avatar avatar-lg rounded-circle">
                                                    <div className="card card-fluid">
                                                        <div className="card-body text-center">
                                                            <div className="avatar-parent-child">
                                                                <a className="avatar avatar-lg rounded-circle">
                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"upload"} color={"black"} title="Accept" size="4x" />
                                                                </a>
                                                                <span className="avatar-child avatar-badge bg-success" />
                                                            </div>
                                                            <h5 className="h6 mt-4 mb-0">Invoices</h5>
                                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        :

                                        roles[5] == true && groups[6] == true ?
                                            <div className="row flex-sm-fill mr-4 ml-2">
                                                <div className="col-sm-4">
                                                    <a href="SubmitPOAcceptance" className="avatar avatar-lg rounded-circle" >

                                                        <div className="card card-fluid">
                                                            <div className="card-body text-center">
                                                                <div className="avatar-parent-child">
                                                                    <a className="avatar avatar-lg rounded-circle">
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"paper-plane"} color={"black"} title="Accept" size="4x" />
                                                                    </a>
                                                                    <span className="avatar-child avatar-badge bg-success" />
                                                                </div>
                                                                <h5 className="h6 mt-4 mb-0">Requested PO Acceptance</h5>

                                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div className="col-sm-4">
                                                    <a href="/ReceivedPOAcceptance" className="avatar avatar-lg rounded-circle">
                                                        <div className="card card-fluid">
                                                            <div className="card-body text-center">
                                                                <div className="avatar-parent-child">
                                                                    <a className="avatar avatar-lg rounded-circle">
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"share-square"} color={"black"} title="Upload" size="4x" />
                                                                    </a>
                                                                    <span className="avatar-child avatar-badge bg-success" />
                                                                </div>
                                                                <h5 className="h6 mt-4 mb-0">Upload Data</h5>
                                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div className="col-sm-4">
                                                    <a href="RequestRetentionPayment" className="avatar avatar-lg rounded-circle">
                                                        <div className="card card-fluid">
                                                            <div className="card-body text-center">
                                                                <div className="avatar-parent-child">
                                                                    <a className="avatar avatar-lg rounded-circle">
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"file"} color={"black"} title="Accept" size="4x" />
                                                                    </a>
                                                                    <span className="avatar-child avatar-badge bg-success" />
                                                                </div>
                                                                <h5 className="h6 mt-4 mb-0">Request Retention Payment</h5>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div className="col-sm-4 pt-2">
                                                    <a href="/AdvancedReceivePayments" className="avatar avatar-lg rounded-circle">
                                                        <div className="card card-fluid">
                                                            <div className="card-body text-center">
                                                                <div className="avatar-parent-child">
                                                                    <a className="avatar avatar-lg rounded-circle">
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"upload"} color={"black"} title="Accept" size="4x" />
                                                                    </a>
                                                                    <span className="avatar-child avatar-badge bg-success" />
                                                                </div>
                                                                <h5 className="h6 mt-4 mb-0">Invoices</h5>
                                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            :
                                            <div className="row flex-sm-fill mr-4 ml-2">
                                                <div className="col-sm-4">
                                                    <a href="RequestPOAcceptance" className="avatar avatar-lg rounded-circle" >

                                                        <div className="card card-fluid">
                                                            <div className="card-body text-center">
                                                                <div className="avatar-parent-child">
                                                                    <a className="avatar avatar-lg rounded-circle">
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"vote-yea"} color={"black"} title="Accept" size="4x" />
                                                                    </a>
                                                                    <span className="avatar-child avatar-badge bg-success" />
                                                                </div>
                                                                {roles[15] ? (<h5 className="h6 mt-4 mb-0">Request PO Acceptance</h5>)
                                                                    : (<h5 className="h6 mt-4 mb-0">PO Details</h5>)}

                                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                    }


                </div>


            </div>
        )
    }
}

const mapStateToProps = (state) => ({ qaTemplate: state.qaTemplate, poDetails: state.poDetails, departmentSearch: state.departmentSearchReducer })
export default connect(mapStateToProps, { getQATemplates, getPODetails, getDepartmentSearch, getPOSearch, inspectionDashboard, getSupplierPOs })(AdvanceDashboard)
